<template>
  <div class="yazipage">
    <router-link class="yazipage-link" :to="{name:'agac'}">
      <img
        class="link-image page-nav-link"
        src="images/arrow-up-white-03.png"
        alt
        style="max-height: 50px; position: relative;"
      />
    </router-link>

    <div class="siir-eng">
      <p>
        An acrid slit coming down from the sky
        <br />All eyes think it&#39;s a victory
        <br />Shining an invisible land far away
        <br />Now time strikes to the leaves
      </p>
      <p>
        The gods can brag about my death
        <br />I see the dog teeth in their laughter
        <br />Not deeper than the fork I hold
        <br />Not whiter than my milk-washed body
        <br />Not aware of the goodness I tear from my skin
      </p>
    </div>
    <div class="siir">
      <p>
        Gökyüzünden buruk bir yarık iniyor
        <br />Bütün gözler bunu zafer sanıyor
        <br />Parlıyor uzaklarda görünmeyen ülke
        <br />Yapraklar artık zamana çarpıyor
      </p>
      <p>
        Tanrılar ölümümle övünebilir
        <br />Kahkahalarında köpek dişlerini görüyorum
        <br />Elimdeki çataldan derin değil
        <br />Sütle yıkanmış vücudumdan daha beyaz değil
        <br />Derimden yüzerek attığım iyilikten haberdar değil
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "YaziPage"
};
</script>

<style scoped>
.yazipage {
  background-color: #303030;
  color: white;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: "serif";
  font-style: oblique;
}

.yazipage p {
  filter: drop-shadow(0px 0px 3px rgba(255, 255, 255, 1));
  font-size: 40px;
}

.yazipage-link {
  filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.4));
}

.yazipage-link > img {
  filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0));
}

.yazipage-link:hover {
  filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.75));
}

.siir {
  transition: opacity 0.5s;
  position: absolute;
  pointer-events: none;
  padding-top: 42px;
  opacity: 0;
}

.siir-eng:hover {
  opacity: 0;
}

.siir-eng:hover + .siir {
  opacity: 1;
}

.siir-eng {
  opacity: 1;
  transition: opacity 0.5s;
}
</style>